import { render, staticRenderFns } from "./appRadio.vue?vue&type=template&id=472192ac"
import script from "./appRadio.vue?vue&type=script&lang=js"
export * from "./appRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports